import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { Address } from "../interfaces/Address";

interface Props {
  onAuthError?: () => void;
}

export default class AddressAPIs extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.META_API}/api/Address/`;

  getAddressById = (addressId: number): Promise<Address> => {
    const apiAddress = `${AddressAPIs.BASE_URL}${addressId}`;
    return this.apiResponseHandler.get(apiAddress);
  };

  editAddress = async (address: Address): Promise<any> => {
    var apiAddress = `${AddressAPIs.BASE_URL}${address.id}`;
    return this.apiResponseHandler.put(apiAddress, JSON.stringify(address), false);
  };
}
